import type { ToteEngagementMode } from '@mote/api'
import { Block, Text } from '@mote/ui'
import { useToteCardContext } from '../ToteCardProvider'
import { getMemeSrc } from '../helpers'
import type { ToteEngagementModeWithAwaiting } from '../types'
import { Header, StyledImage } from './Shared.styles'
import { StyledInfoIconButton } from './TeacherTesponse.styles'
import { MemeContainer } from './Teply.styles'
import { Tesponse } from './Tesponse'
import { useMemeTimeout } from './useMemeTimeout'

export interface TeacherTesponseProps {
  lastSeenDate: string
  studentName: string
  image: string
  tesponse: string | null
  mode: ToteEngagementModeWithAwaiting
  transparent?: boolean
  shouldShowInstructionLink: boolean
}
export function TeacherTesponse(props: TeacherTesponseProps): JSX.Element {
  const toteCardContext = useToteCardContext()
  const shouldShowMeme = useMemeTimeout(props.image)

  if (shouldShowMeme) {
    return (
      <MemeContainer>
        <StyledImage
          src={getMemeSrc(props.mode as ToteEngagementMode, props.image)}
        />
      </MemeContainer>
    )
  }

  return (
    <Block gap={toteCardContext.config.spacing}>
      <Header {...toteCardContext.config.textStyles}>
        {props.studentName} response:
      </Header>
      <Tesponse
        mode={props.mode}
        transparent={props.transparent}
        tesponse={props.tesponse}
      />
      <Block
        className='mote-tote-card__tesponse-seen'
        layout='horizontal'
        align='center'
        gap={4}
      >
        <Text
          tag='span'
          fontWeight={400}
          color='grey.d2'
          {...toteCardContext.config.dateTextStyles}
        >
          {props.lastSeenDate}
        </Text>
        {props.shouldShowInstructionLink ? (
          <StyledInfoIconButton
            size={toteCardContext.config.infoButtonSize}
            //@ts-expect-error
            variant='ghost'
            tooltipProps={{ content: 'What do students see?', direction: 'up' }}
            aria-label='See student view'
            href={'https://support.mote.com/hc/en-us/articles/7076116321428'}
            target={'_blank'}
            showTooltip
          />
        ) : null}
      </Block>
    </Block>
  )
}
